import { Box, Button, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { enqueueSnackbar } from "notistack";
import { Dispatch, useMemo, useState } from "react";

type PageFilterLoaderProps = {
  p?: number,
  marginBottom?: number,
  pageFilterData: PageFilterLoaderData,
  onRun: () => void
}

export type PageFilterLoaderData = {
  fromDate?: string,
  setFromDate: Dispatch<React.SetStateAction<string | undefined>>,
  toDate?: string,
  setToDate: Dispatch<React.SetStateAction<string | undefined>>
}

export function usePageFilterLoaderData(defaultFromDate?: string, defaultToDate?: string): PageFilterLoaderData {
  const [fromDate, setFromDate] = useState<string | undefined>(defaultFromDate);
  const [toDate, setToDate] = useState<string | undefined>(defaultToDate);

  return useMemo(
    () => ({ fromDate, setFromDate, toDate, setToDate }),
    [fromDate, setFromDate, toDate, setToDate]
  )
}

export default function PageFilterLoader({ pageFilterData, onRun, p, marginBottom }: PageFilterLoaderProps) {
  return <Box sx={{p: p ?? 2, pl: 0, marginBottom: marginBottom ?? 2 }}>
    <Stack gap={1} direction="row">
      <DatePicker
        value={!pageFilterData.fromDate ? null : dayjs(pageFilterData.fromDate)}
        onChange={(date: Dayjs | null) => pageFilterData.setFromDate(date?.format("YYYY-MM-DD"))}
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small"
          },
        }}
        sx={{
          maxWidth: { md: 180 },
        }}
      />

      <DatePicker
        value={!pageFilterData.toDate ? null : dayjs(pageFilterData.toDate)}
        onChange={(date: Dayjs | null) => pageFilterData.setToDate(date?.format("YYYY-MM-DD"))}
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small"
          },
        }}
        sx={{
          maxWidth: { md: 180 },
        }}
      />

      <Button variant="soft" onClick={() => {
        if (!pageFilterData.fromDate || !pageFilterData.toDate) {
          enqueueSnackbar("Please select a date range", { variant: "error" });
          return;
        }
        onRun()
      }}>
        Go
      </Button>
    </Stack>
  </Box>
}